
define(function(){
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const builder = require('civicsUtils/buildUrlParameters');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IpsModelCollection.extend({
	url: function() {
		if(AvailableFeatures.AdditionalDashboardFilters()){
			return '/delegate/civics-api/api/portal/myinstrumentsubtypes';
		}else{
			let urlRoot = '/delegate/civics-api/api/core/views/instrumentsubtypecodes';
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters)
			}
			if (parameters.indexOf('?') >= 0) {
				parameters += '&Page=[{Max:0}]';
			} else {
				parameters += '?Page=[{Max:0}]';
			}
			return urlRoot + parameters;
		}
	},
    parse: function(response) {
			var data = response.data ? response.data : [];
			var values = [];
			var returnValues = [];

			for (var i = 0; i < data.length; i++) {
				if (data[i].code && data[i].code.trim() != '' || (AvailableFeatures.AdditionalDashboardFilters() && data[i].instrumentSubType && data[i].instrumentSubType.trim() != '')) {
					var obj = {};
					obj.value = data[i].code ? data[i].code : data[i].instrumentSubType;
					obj.displayName = data[i].description ? data[i].description.trim() : (data[i].instrumentSubTypeDescription ? data[i].instrumentSubTypeDescription.trim() : '');
					obj.propertyName = 'instrumentSubTypeCode';
					values.push(obj);
				}
			};

			//make the type list unquie based on the display name
			returnValues = _.uniq(values, function (e) {
				return e.displayName;
			});

			returnValues.sort(function (a, b) {
				return a.displayName.localeCompare(b.displayName, undefined, { numeric: true, sensitivity: 'base' });
			});

			// Get the other related values with the same displayName
			var groupByDisplayName = _.groupBy(values, function(e) { 
				return e.displayName;
			});
			_.each(returnValues, function(rtnObj) {
				rtnObj.relatedValues = [];
				
				_.each(groupByDisplayName[rtnObj.displayName], function(grpByObj) {
					if (grpByObj.value != rtnObj.value && rtnObj.relatedValues.indexOf(grpByObj.value) == -1)
						rtnObj.relatedValues.push(grpByObj.value);
				});
			});

			return returnValues;
		}
  });

});
